import React, { useEffect, useRef } from 'react';

/**
 * A Checkbox component that can display an indeterminate state.
 * The 'indeterminate' property will be extracted from props and used to set the indeterminate state. 
 * All other props will be passed to the input.
 */
export default function IndeterminateCheckBox(props) {
	const ref = useRef(null);
	const { indeterminate, ...rest } = props;

	useEffect(() => {
		if (ref) {
			ref.current.indeterminate = indeterminate;
		}
	}, [indeterminate]);

	return <input type="checkbox" {...rest} ref={ref} />;
}
